import * as React from 'react';

import type { TypedBarChart } from './BarChart.lazy';

export const BarChart = React.lazy(() =>
    import('./BarChart.lazy').then((module) => ({
        default: module.BarChart,
    }))
) as TypedBarChart;

export type { BarChartProps } from './BarChart.lazy';
